module.exports = __webpack_public_path__ + "img/DW365-276.6532b656.jpg";